<template>
  <Layout
    username="Administrator"
    current-page="Companies"
    link-to-edit="/admin-dashboard/edit-profile"
  >
    <template slot="menuItems">
      <li v-for="{ title, icon, path } in menu" :key="title" class="nav-item">
        <MenuItems :menu-item="title" :icon-menu="icon" :to-where="path" />
      </li>
    </template>
    <template slot="content">
      <div class="row">
        <div v-if="isFetching" class="col col-lg-6">
          <a-skeleton :paragraph="{ rows: 16 }" />
        </div>
        <div v-else class="col col-lg-6">
          <div class="mb-2">
            <p class="my-1">Company Name</p>
            <a-input
              placeholder="Name"
              size="large"
              label="Email"
              v-model="company.name"
            />
          </div>
          <div class="mb-2">
            <p class="my-1">Company Email</p>
            <a-input
              placeholder="luc@example.com"
              size="large"
              v-model="company.email"
            />
          </div>
          <div class="mb-2">
            <p class="my-1">Company Address</p>
            <a-input
              placeholder="Kimironko / Kigali"
              size="large"
              v-model="company.address"
            />
          </div>
          <div class="mb-2">
            <p class="my-1">Company Phone</p>
            <a-input
              placeholder="0786....."
              size="large"
              v-model="company.phoneNumber"
            />
          </div>
          <div class="mb-2">
            <p class="my-1">Password</p>
            <a-input
              placeholder="Password"
              type="password"
              size="large"
              class="m-0"
            />
          </div>
          <div class="row justify-content-between my-4 mx-1">
            <a-button
              type="primary"
              class="col col-lg-5"
              size="large"
              :loading="isSubmitting"
              @click="updateCompany()"
              >Update</a-button
            >
            <a-button
              type="danger"
              class="col col-lg-5"
              size="large"
              @click="showConfirm"
              >Delete</a-button
            >
          </div>
        </div>
      </div>
    </template>
  </Layout>
</template>

<script>
import Layout from "../../../components/Layout";
import MenuItems from "../../../components/MenuItems";
import http from "../../../helpers/http";
export default {
  components: {
    Layout,
    MenuItems,
  },
  data() {
    return {
      timer: null,
      isFetching: true,
      isSubmitting: false,
      company: {},
      menu: [
        {
          title: "Dashboard",
          icon: "fa fa-chart-line",
          path: "/admin",
        },
        {
          title: "Add Company",
          icon: "fa fa-plus",
          path: "/admin/companies/new",
        },
        {
          title: "Companies",
          icon: "fa fa-table",
          path: "/admin/companies",
        },
        {
          title: "Sales",
          icon: "fa fa-table",
          path: "/admin/admin-sales",
        },
      ],
    };
  },
  watch: {
    // call again the method if the route changes
    $route: "fetchCompany",
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: "normal_login" });
  },
  created() {
    this.fetchCompany();
  },

  methods: {
    async fetchCompany() {
      try {
        const { data } = await http.get(`/companies/${this.$route.params.id}`);
        this.company = ["name", "email", "address", "phoneNumber"].reduce(
          (prev, key) => ({
            ...prev,
            [key]: data[key],
          }),
          {}
        );
      } catch (error) {
        console.log(error);
      } finally {
        this.isFetching = false;
      }
    },
    async updateCompany() {
      this.isSubmitting = true;
      try {
        const { data } = await http.put(
          `/companies/${this.$route.params.id}`,
          this.company
        );
        console.log(data);
        this.isSubmitting = false;
      } catch (error) {
        console.log(error);
        this.isSubmitting = false;
      }
    },

    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
        }
      });
    },
    onDelete() {
      return http
        .delete(`/companies/${this.$route.params.id}`)
        .then(() => this.$router.go(-1))
        .catch((err) => this.$message.error(err.message || err));
    },
    showConfirm() {
      this.$confirm({
        title: "Do you want to delete these items?",
        // content:
        //   "When clicked the OK button, this dialog will be closed after 1 second",
        onOk: this.onDelete,
        onCancel() {},
      });
    },
  },
};
</script>

<style>
</style>